export default "__VITE_ASSET__6a941e16__"